import { Activity, ShieldCheck, X } from "lucide-react";

export function Brand() {
  return <div className="brand" data-testid="brand-mark"><div className="brand-icon"><ShieldCheck size={20} /><Activity size={17} /></div><div><b>dentaflow<span>ai</span></b><small>voice ledger</small></div></div>;
}

export function Modal({ eyebrow, title, onClose, onSubmit, children, testid, wide }) {
  return (
    <div className="modal-backdrop" data-testid={`${testid}-backdrop`}>
      <form className={wide ? "modal wide" : "modal"} onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }} data-testid={testid}>
        <div className="modal-head"><div><p className="eyebrow">{eyebrow}</p><h2>{title}</h2></div><button type="button" className="icon-btn" onClick={onClose} data-testid={`${testid}-close`}><X /></button></div>
        {children}
      </form>
    </div>
  );
}

export function Field({ label, testid, value, onChange, textarea, options, type = "text", ...rest }) {
  const change = (e) => onChange(e.target.value);
  let input;
  if (textarea) input = <textarea data-testid={testid} value={value ?? ""} onChange={change} {...rest} />;
  else if (options) input = <select data-testid={testid} value={value ?? ""} onChange={change} {...rest}>{options.map((o) => <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}</select>;
  else input = <input data-testid={testid} type={type} value={value ?? ""} onChange={change} {...rest} />;
  return <label>{label}{input}</label>;
}

export const ErrorBox = ({ error, testid }) => (error ? <div className="error" data-testid={testid}>{error}</div> : null);

export function PageHeading({ eyebrow, title, accent, sub, children }) {
  return <div className="page-heading compact"><div><p className="eyebrow">{eyebrow}</p><h1>{title} <em>{accent}</em></h1>{sub && <p className="muted">{sub}</p>}</div>{children && <div className="heading-actions">{children}</div>}</div>;
}

export function Empty({ icon: Icon, title, text, testid }) {
  return <div className="empty" data-testid={testid}><Icon size={24} /><b>{title}</b><span>{text}</span></div>;
}

export const StatusBadge = ({ value, testid }) => <span className={`badge ${value}`} data-testid={testid}>{(value || "").replaceAll("_", " ")}</span>;
